import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { TranslationService } from 'src/app/modules/i18n/translation.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
declare const fabric: any;


@Component({
  selector: 'app-congrats-edit-modal',
  templateUrl: './congrats-edit-modal.component.html',
  styleUrls: ['./congrats-edit-modal.component.scss']
})
export class CongratsEditModalComponent implements OnInit {
  language: any;
  canvas: any;
  text: any;
  Name: string = '';
  selectedColor = "Black";
  AnotherColor: boolean = false;
  AnotherColortxt = '';
  @ViewChild('myCanvas') canvasRef: ElementRef;
  @Input() data: any;

  colors = ['#405076','#3672B9','#3ABBE8','#A2215D','#A36861'];

  constructor(private translationService: TranslationService, public modal: NgbActiveModal) { }

  ngOnInit(): void {
    this.language = this.translationService.getSelectedLanguage();
    this.canvas = new fabric.Canvas('canvas');
    fabric.Image.fromURL(this.data.image, (img) => {
      const newWidth = 700;
      const newHeight = 500;
      
      // Scale the image to the new size
      img.scaleToWidth(newWidth);
      img.scaleToHeight(newHeight);

      
      this.canvas.setBackgroundImage(img, this.canvas.renderAll.bind(this.canvas));
    });
    this.text = new fabric.Text('', {
      left: 100,
      top: 100,
      fontSize: 36,
      fontFamily: 'Arial',
      fontWeight: 'Bold',
      fill: 'Black',
      selectable: true,
      editable: true,
      draggable: true,
    });

    this.canvas.add(this.text);

    this.canvas.on('object:moving', (e) => {
      const obj = e.target;
      if (obj.type === 'text') {
        obj.setCoords();
        const textPos = obj.getBoundingRect();
        const imgPos = this.canvas.backgroundImage.getBoundingRect();
        if (textPos.left < imgPos.left || textPos.top < imgPos.top ||
          textPos.left + textPos.width > imgPos.left + imgPos.width ||
          textPos.top + textPos.height > imgPos.top + imgPos.height) {
          obj.left = obj.lastLeft;
          obj.top = obj.lastTop;
          obj.setCoords();
        } else {
          obj.lastLeft = obj.left;
          obj.lastTop = obj.top;
        }
      }
    });

  }
  UpdateText() {
    if (this.selectedColor == '') {
      this.AnotherColor = true;
      this.AnotherColortxt == '' ? this.text.set('fill', "Black") : this.text.set('fill', this.AnotherColortxt);
    }
    else {
      this.AnotherColor = false;
      this.text.set('fill', this.selectedColor);
    }
    this.text.set('text', this.Name);
    this.canvas.renderAll();
  }
  SaveImage() {
    // Export the canvas to a data URL
    const dataURL = this.canvas.toDataURL();

    // Convert the data URL to a Blob object
    const blob = this.dataURLtoBlob(dataURL);

    // Create a link element to download the image
    const link = document.createElement('a');
    link.download = 'image.png';
    link.href = window.URL.createObjectURL(blob);

    // Click the link to download the image
    link.click();
  }
  dataURLtoBlob(dataURL: string): Blob {
    const arr = dataURL.split(',');
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }
  onNoClick(): void {
    this.modal.close();
  }
}

